
import { useState, useEffect } from 'react';
import { __ } from '@wordpress/i18n';

const { PanelBody, __experimentalInputControl: InputControl, Button } = wp.components;
const { registerPlugin } = wp.plugins;
const { PluginSidebar, PluginSidebarMoreMenuItem } = wp.editPost;

import useWPOptionMutation from './hooks/useWPOptionMutation';
import useWPOptionQuery from './hooks/useWPOptionQuery';
import { blockIcon } from './utils/icons';
const ytvgbEvent = new CustomEvent('ytvgbEvent');

const RenderPlugin = () => {

    const [ifbData, setIfbData] = useState({});
    const { key = '' } = ifbData || {};
    const { data: firstData = {}, isLoading: loadingOnGet } = useWPOptionQuery('ytvgb-video-gallery');
    const { isLoading: loadingOnSet, saveData } = useWPOptionMutation('ytvgb-video-gallery', { dataType: 'object' });

    // Get first data
    useEffect(() => {
        if (!loadingOnGet) {
            setIfbData({ ...firstData });
        }
    }, [loadingOnGet]);

    // Save to database
    const onSaveData = () => {
        if (!loadingOnSet) {
            saveData(ifbData);
            // clearCache();
        }
    }

    useEffect(() => {
        if (!loadingOnSet) {
            window.dispatchEvent(ytvgbEvent);
        }
    }, [loadingOnSet]);


    return <>
        <PluginSidebarMoreMenuItem target='instagram-feed'>{__('Youtube', 'yt-video-gallery')}</PluginSidebarMoreMenuItem>

        <PluginSidebar className='bPlPluginSidebar' name='youTube-video-gallery' title={__('Youtube', 'yt-video-gallery')}>
            <PanelBody className='bPlPanelBody ytvgbbPlPanelBody' title={__('Youtube API key', 'yt-video-gallery')} initialOpen={true}>

                <InputControl className="ytvgbInputControl" value={key} onChange={val => { setIfbData({ ...ifbData, key: val }); }} />
                <div className='ytvgbApiKeyConfig'>
                    <a href='https://bplugins.com/docs/video-gallery-for-youtube/guides/credentials/#authorization' target="_blank" rel='noreferrer'>Get Api Key</a>
                </div>
                <Button className='apiBtn' disabled={loadingOnSet} onClick={onSaveData} >{__('Save Information', 'yt-video-gallery')}</Button>

            </PanelBody>
        </PluginSidebar>
    </>
};

registerPlugin('ytvgb-gallery', {
    icon: blockIcon,
    render: RenderPlugin
});